import { PortfoliosInvestmentspecService } from '@festina/unitlink-general-types/unitlink/services/PortfoliosInvestmentspecService'
import { PortfolioSourcesEventsService } from '@festina/unitlink-general-types/unitlink/services/PortfolioSourcesEventsService'
import { useCreateCommandActions } from '@festina-life/authentication'

import type { PortfolioActionProps } from '../types'

class PortfoliosInvestmentspecServiceOverwrite extends PortfoliosInvestmentspecService {
  static portfolioSourcesServiceDeleteCancelEvent =
    PortfolioSourcesEventsService.portfolioSourcesServiceDeleteCancelEvent

  static portfolioSourcesServiceDeleteCancelEvent_roles =
    PortfolioSourcesEventsService.portfolioSourcesServiceDeleteCancelEvent_roles

  static portfolioSourcesServicePutEvents = ({
    requestBody: commandData,
    ...rest
  }: Parameters<
    typeof PortfoliosInvestmentspecService.portfolioInvestmentSpecServiceV2PostInvestmentspecs
  >[0] & { eventId: string }) =>
    PortfolioSourcesEventsService.portfolioSourcesServicePutEvents({
      ...rest,
      requestBody: {
        _type: 'UpdateInvestmentSpecCommand',
        commandData,
      },
    })

  static portfolioSourcesServicePutEvents_roles =
    PortfolioSourcesEventsService.portfolioSourcesServicePutEvents_roles
}

export const useInvestmentSpecActions = (
  serviceArguments: PortfolioActionProps,
) =>
  useCreateCommandActions({
    component: 'unitLink',
    service: PortfoliosInvestmentspecServiceOverwrite,
    methods: {
      create: 'portfolioInvestmentSpecServiceV2PostInvestmentspecs',
      cancel: 'portfolioSourcesServiceDeleteCancelEvent',
      update: 'portfolioSourcesServicePutEvents',
    },
    serviceArguments: {
      eventId: serviceArguments.commandId ?? '', // will be there when needed
      ownerId: serviceArguments.ownerId,
    },
  })
